module.exports = __webpack_public_path__ + "media/krovah.2939bcac.mp3";